import store from "../../store";
import { canAccessMetalnord } from "../metalnord/access.mjs";
import { canAccessCatalog } from "./kpiCatalog/catalogHelpers.mjs";

const ControlloPrezzi = () => import("./ControlloPrezzi");
const ControlloPrezziCliente = () => import("./ControlloPrezziCliente");
const ControlloOdv = () => import("./ControlloOdvPage");
const FixStorico = () => import("./FixStorico");
const BudgetPrevisionale = () => import("./BudgetPrevisionale");
const ManutenzioniDashboard = () => import("./ManutenzioniDashboard");
const ParserOrdini = () => import("./ParserOrdini");
const PhaseParameters = () => import("./PhaseParameters");

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next();
        return;
    }
    next("/login");
};

const ifAdministration = (to, from, next) => {
    if (!store.getters.isLoggedIn) return next("/login");
    if (!store.getters.hasGroups(["Amministrazione"])) return next("/");
    return next();
};

export default [
    {
        path: "/staff/metalnord/",
        alias: "/metalnord",
        name: "staff-metalnord",
        meta: { menu: "staff", title: "Metalnord · prepara l’incontro" },
        component: () => import("../metalnord/MetalnordPage.vue"),
        beforeEnter: (to, from, next) => {
            if (!store.getters.isLoggedIn) return next("/login");
            return next(canAccessMetalnord(store.getters.userdata) ? undefined : "/");
        },
    },
    {
        path: "/staff/centri-lavoro/",
        name: "staff-centri-lavoro",
        meta: { menu: "staff", title: "Centri di lavoro" },
        component: () => import("./centri/CentriLavoro.vue"),
        beforeEnter: (to, from, next) => {
            if (!store.getters.isLoggedIn) return next({ path: "/login", query: { next: to.fullPath } });
            next();
        },
    },
    {
        path: "/catalogo-kpi",
        name: "staff-kpi-catalog",
        meta: { menu: "staff", title: "Catalogo KPI", access: { key: "kpi.catalog", admin: true, defaultGroups: [] } },
        component: () => import("./KpiCatalog.vue"),
        beforeEnter: (to, from, next) => {
            if (!store.getters.isLoggedIn) return next("/login");
            return canAccessCatalog(store.getters.userdata) ? next() : next("/");
        },
    },
    {
        path: "/staff/prezzi/:mese?",
        name: "staff-prezzi",
        meta: { menu: "staff", title: "Controllo Prezzi" },
        component: ControlloPrezzi,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/prezzicliente/:cliente/:indirizzo/:validate/:mese?",
        name: "staff-prezzicliente",
        meta: { menu: "staff", title: "Controllo Prezzi Cliente" },
        component: ControlloPrezziCliente,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/controllodv/",
        name: "staff-controllodv",
        meta: { menu: "staff", title: "Controllo Ordini di Vendita" },
        component: ControlloOdv,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/budgetprevisionale/",
        name: "staff-budgetprevisionale",
        meta: { menu: "staff", title: "Budget Previsionale" },
        component: BudgetPrevisionale,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/manutenzioni/",
        name: "staff-manutenzioni",
        meta: { menu: "staff", title: "Manutenzioni" },
        component: ManutenzioniDashboard,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/parametri-fasi/",
        name: "staff-parametri-fasi",
        meta: { menu: "staff", title: "Parametri fasi di lavoro" },
        component: PhaseParameters,
        beforeEnter: ifAdministration,
    },
    {
        path: "/staff/parser-ordini/",
        name: "staff-parser-ordini",
        meta: { menu: "staff", title: "Parser ordini cliente" },
        component: ParserOrdini,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/staff/fixstorico/",
        name: "staff-fixstorico",
        meta: { menu: "staff", title: "Fix Storico" },
        component: FixStorico,
        beforeEnter: ifAuthenticated,
    },
];
